/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconCompass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconCompass"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m0 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16"
    />
    <path
      fill="currentColor"
      d="M14.205 14.205 16.41 7.59 9.795 9.795 7.59 16.41zm-.958-3.452-.624 1.87-1.87.624.623-1.87z"
    />
  </svg>
);
export default IconCompass;
